























import { PosVehicleState } from 'gl-ms-positions';

export const COLOR_MAP:any = {
    [PosVehicleState.IN_MOVEMENT_WITH_TRIP]: {
        color: '#00B2B0',
        dotted: false,
    },
    [PosVehicleState.STUCK_WITH_TRIP]: {
        color: '#00B2B0',
        dotted: true,
    },
    [PosVehicleState.IN_WARNING_WITH_TRIP]: {
        color: '#F4BD0B',
        dotted: false,
    },
    [PosVehicleState.IN_ERROR_WITH_TRIP]: {
        color: '#EE3125',
        dotted: false,
    },
    [PosVehicleState.NO_TRIP_ASSIGNED]: {
        color: '#231F20',
        dotted: true,
    },
};

export default {
    data() {
        return {
            isActive: true,
        };
    },
    props: ['status'],
    computed: {
        color(this: any) {
            if (COLOR_MAP[this.status]) {
                return COLOR_MAP[this.status].color;
            }

            return '#AAA';
        },
        dotted(this: any) {
            if (COLOR_MAP[this.status]) {
                return COLOR_MAP[this.status].dotted;
            }

            return false;
        },
    },
    components: {
    },
    methods: {
        click(this:any) {
            this.isActive = !this.isActive;
            this.$emit('click', { active: this.isActive, status: this.status });
        },
    },

    mounted(this: any) {
    },
};
